import { RESET_FORM_TO_DEFAULT } from './actionTypes';

export function resetForm() {
    return { type: RESET_FORM_TO_DEFAULT };
}